import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, isAdmin, loading } = useAuth();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-ink"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={adminOnly ? '/admin' : '/'} replace />;
  }

  // Admin users should always go to admin panel, not influencer pages
  if (isAdmin && !adminOnly) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  // Admin panel only accessible from desktop
  if (adminOnly) {
    if (!isAdmin) {
      return <Navigate to="/admin" replace />;
    }
    
    if (isMobile) {
      return (
        <div className="flex items-center justify-center min-h-screen p-8 text-center">
          <div>
            <h1 className="text-2xl font-bold text-brand-ink font-brand font-normal mb-4">
              Admin Paneli
            </h1>
            <p className="text-gray-600">
              Admin paneline sadece masaüstü bilgisayardan erişebilirsiniz.
            </p>
          </div>
        </div>
      );
    }
  }

  return children;
};

export default ProtectedRoute;
